export default "__VITE_ASSET__ByOXxE$c__"